import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PonBoxCantonEditingDialog from '../DialogEditingType/PonBoxCantonEditingDialog';
import { PON_BOX, PON_BOX_FLAG, ROLE_ADMIN, ROLE_ENGINNER, ROLE_MASTER, ROLE_SENIOR_MASTER } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import { fetchPonBoxConnectionCount } from '../CountFile/ConnectionCount';
import { fetchCouplingFileCount, fetchPonBoxFileCount } from '../CountFile/FileCount';
import DialogPonBoxFoto from '../DialogFoto/DialogPonBoxFoto';

const PonBoxCantonDialog = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, role, user, cantonRefresh, groupedCoordinatesWithColorTypeAndWidth,
  wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, setIsComponentСhangeCoorPonBox, territoryList}) => {

  const [openModalEditing, setOpenModalEditing] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [connectionCount, setConnectionCount] = useState(0);
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [fileCount, setFileCount] = useState(0);


  const openModalDescriptionComponents = () => {
    if(connectionCount != 0){
      setOpenModalDescription(true);
    }
  }; 

  const openModalEditingContent = () => {
    setOpenModalEditing(true);
  };  

  useEffect(() => {
    const updateConnectionCount = async () => {  
      const count = await fetchPonBoxConnectionCount(content.id);
      if (count !== null) {
        setConnectionCount(count); 
      }
    };
    updateConnectionCount();
  });

   useEffect(() => {
    const updateFileCount = async () => {  
      const count = await fetchPonBoxFileCount(content.id);
      if (count !== null) {
        setFileCount(count); 
      }
    };
    updateFileCount();
  });

  const openModalFotoFile = () => {
  if(fileCount != 0){
    setOpenModalFoto(true);
  }
 }; 

  return (
    <Dialog open={open} className="dialogStyle">
    <DialogContent>
           <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #000000ff'}}>Пон-бокс</label>
    <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' ,textShadow: '2px 2px 4px #141414ff'}}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "фоб"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #161616ff' }}>{content.city}</span> </label>
      <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#de858e' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
              <hr className='horizontalLineDialog'/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Пон-бокс: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #080808ff' }}>{content.fobName}</span> </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип прихода: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #080808ff' }}>{content.comingType}</span> </label>
      <br/>
      {/* <label style={{ color: '#292929', fontWeight: 'bold'}}>Делитель: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{content.dividerModel} <br/>{content.dividerModel2}</span> </label>
      <br/> */}
     <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px', color: '#292929', fontWeight: 'bold' }}>
        <span>Делитель:</span>
        <div style={{ display: 'flex', flexDirection: 'column', color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #0f0f0fff' }}>
          <span>{content.dividerModel}</span>
          {content.divider2Id !== 5 && <span>{content.dividerModel2}</span>}
        </div>
      </div>
      
        <label style={{ color: '#292929', fontWeight: 'bold' }}>
           Признак: 
           <span style={{ color: content.ether === 1 || content.pon === 1 || content.ktv === 1 ? '#bdab6f' : '#de858e',textShadow: '2px 2px 4px #111111ff' }}>
             {[
                content.pon === 1 && ' PON',
                content.ktv === 1 && ' KTV',
                content.ether === 1 && ' Ethernet'
             ]
              .filter(Boolean)
             .join(', ') || ' Нет'}
           </span>
        </label>
       
        {content.numberBox && (
          <>
           <br/>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>
            Номер бокса: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #161616ff' }}>{content.numberBox}</span>
          </label>
           <br/>
          </> 
        )}
       
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #1b1b1bff' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #1a1a1aff' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #131313ff' }}>{content.description}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #2b2b2bff'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
        </button>

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalFotoFile} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #252525ff'}}>
        Просмотр файлов
        <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
           {fileCount > 0 ? fileCount : 'нет'}
        </span>
      </button>

    </DialogContent>

    <DialogActions>
    {/* {((user === content.authorId && (role.role === ROLE_ENGINNER || role.role === ROLE_SENIOR_MASTER )) || role.role === ROLE_ADMIN) && ( */}
     {(
      (
        (user === content.authorId &&
        (role.role === ROLE_ENGINNER || role.role === ROLE_MASTER)
        ) ||
        role.role === ROLE_ADMIN ||
       (role.role === ROLE_ENGINNER  && territoryList.includes(content.canton))
      )       
     ) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
      </Button>
    )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

   {/* Snackbar */}
   <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={PON_BOX}
          flag={PON_BOX_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />
      
      {/* Modal редактирование FobCanton*/}
      <PonBoxCantonEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        user={user}
        cantonRefresh={cantonRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoorPonBox={setIsComponentСhangeCoorPonBox}
      /> 

       {/* Modal Foto*/}
        <DialogPonBoxFoto
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}     
      />              
    </Dialog> 
  );
}

export default PonBoxCantonDialog;